import { createSlice } from "@reduxjs/toolkit";
import {
  addPaymentMethod,
  fetchPaymentMethodsByUserId,
  removePaymentMethod,
  updateDefaultPaymentMethod,
} from "./paymentMethodActions";

const initialState = {
  paymentMethods: [],
  isLoading: false,
  isAddPaymentMethodLoading: false,
  isRemovePaymentMethodLoading: false,
  isUpdateDefaultPaymentMethodLoading: false,
  error: null,
};

export const paymentMethodSlice = createSlice({
  name: "paymentMethod",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // Fetch Payment Methods By User ID
      .addCase(fetchPaymentMethodsByUserId.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPaymentMethodsByUserId.fulfilled, (state, action) => {
        state.paymentMethods = action.payload || [];
        state.isLoading = false;
        state.error = null;
      })
      .addCase(fetchPaymentMethodsByUserId.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Fetch Payment Methods By User ID
      .addCase(addPaymentMethod.pending, (state) => {
        state.isAddPaymentMethodLoading = true;
      })
      .addCase(addPaymentMethod.fulfilled, (state, action) => {
        const newMethod = action.payload;
        let updatedMethods = state.paymentMethods.map((pm) =>
          newMethod.is_default ? { ...pm, is_default: false } : pm
        );
        updatedMethods = [newMethod, ...updatedMethods];
        state.paymentMethods = updatedMethods;
        state.isAddPaymentMethodLoading = false;
        state.error = null;
      })
      .addCase(addPaymentMethod.rejected, (state, action) => {
        state.isAddPaymentMethodLoading = false;
        state.error = action.payload;
      })
      // Remove Payment Method
      .addCase(removePaymentMethod.pending, (state) => {
        state.isRemovePaymentMethodLoading = true;
      })
      .addCase(removePaymentMethod.fulfilled, (state, action) => {
        const removedId = action.payload;
        state.paymentMethods = state.paymentMethods.filter(
          (pm) => pm.id !== removedId
        );

        state.isRemovePaymentMethodLoading = false;
        state.error = null;
      })
      .addCase(removePaymentMethod.rejected, (state, action) => {
        state.isRemovePaymentMethodLoading = false;
        state.error = action.payload;
      })
      // Update Default Payment Method
      .addCase(updateDefaultPaymentMethod.pending, (state) => {
        state.isUpdateDefaultPaymentMethodLoading = true;
      })
      .addCase(updateDefaultPaymentMethod.fulfilled, (state, action) => {
        const updatedId = action.payload;

        // Mark only the updated one as default
        state.paymentMethods = state.paymentMethods.map((pm) =>
          pm.id === updatedId
            ? { ...pm, is_default: true }
            : { ...pm, is_default: false }
        );

        state.isUpdateDefaultPaymentMethodLoading = false;
        state.error = null;
      })
      .addCase(updateDefaultPaymentMethod.rejected, (state, action) => {
        state.isUpdateDefaultPaymentMethodLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = paymentMethodSlice.actions;

export default paymentMethodSlice.reducer;
